import React from 'react';
import { motion } from 'framer-motion';
import { useOrderBump } from './OrderBumpContext';
export function OrderBumpSection() {
  const {
    isOrderBumpChecked,
    setIsOrderBumpChecked
  } = useOrderBump();
  return <section className="bg-[#FAF7F2] py-8 md:py-10" data-id="element-295">
      <div className="max-w-[600px] mx-auto px-4" data-id="element-296">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} animate={{
        scale: isOrderBumpChecked ? 1 : [1, 1.012, 1],
        boxShadow: isOrderBumpChecked ? '0 6px 30px rgba(22,163,74,0.15)' : ['0 6px 30px rgba(184,134,11,0.08)', '0 6px 40px rgba(184,134,11,0.22)', '0 6px 30px rgba(184,134,11,0.08)']
      }} transition={{
        scale: {
          duration: 1.8,
          repeat: isOrderBumpChecked ? 0 : Infinity,
          ease: 'easeInOut'
        },
        boxShadow: {
          duration: 1.8,
          repeat: isOrderBumpChecked ? 0 : Infinity,
          ease: 'easeInOut'
        }
      }} onClick={() => setIsOrderBumpChecked(!isOrderBumpChecked)} className={`bg-white rounded-2xl border-2 p-6 md:p-8 cursor-pointer select-none transition-colors duration-300 ${isOrderBumpChecked ? 'border-green-500' : 'border-[#C9A84C]/40'}`} data-id="element-297">
          {/* Checkbox at top */}
          <div className="flex items-center gap-3 mb-5" data-id="element-298">
            <div className={`w-7 h-7 border-2 rounded-md flex items-center justify-center transition-all duration-300 flex-shrink-0 ${isOrderBumpChecked ? 'bg-green-600 border-green-600' : 'border-[#C9A84C] bg-white'}`} data-id="element-299">
              {isOrderBumpChecked && <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-300">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-301" />
                </svg>}
            </div>
            <p className={`font-bold text-base md:text-lg uppercase tracking-wide ${isOrderBumpChecked ? 'text-green-600' : 'text-[#B8860B]'}`} data-id="element-302">
              {isOrderBumpChecked ? '✅ Agregado a tu pedido' : 'Sí, quiero sumar el Packaging Luxury'}
            </p>
          </div>

          {/* Headline */}
          <h2 className="font-serif text-2xl md:text-3xl font-bold text-[#3D1F0D] text-center mb-4 leading-tight" data-id="element-303">
            ¿Querés cobrar 3 veces más por cada torta?
          </h2>

          {/* Description — moved right after headline */}
          <p className="text-[#3D1F0D]/75 text-sm md:text-base leading-relaxed text-center mb-6 max-w-md mx-auto" data-id="element-304">
            💰 Aprendé a empacar tus milhojas como una marca de lujo: 10 diseños
            exclusivos, materiales baratos con look premium y la guía exacta
            para que tus clientes paguen 3 veces más solo por la presentación.
          </p>

          {/* Imagen del Producto — Luxury Box */}
          <div className="flex justify-center" data-id="element-305">
            <div className="relative" data-id="element-306">
              {/* Main luxury box */}
              <div className="w-52 h-64 rounded-xl overflow-hidden shadow-[0_8px_30px_rgba(125,31,46,0.2)]" data-id="element-307">
                {/* Box body */}
                <div className="h-full bg-gradient-to-b from-[#1a0a0e] via-[#2d1018] to-[#1a0a0e] relative flex flex-col" data-id="element-308">
                  {/* Gold trim top */}
                  <div className="h-1.5 bg-gradient-to-r from-transparent via-[#C9A84C] to-transparent" data-id="element-309"></div>

                  {/* Ribbon horizontal */}
                  <div className="absolute top-1/2 -translate-y-1/2 w-full h-6 bg-gradient-to-r from-[#7D1F2E] via-[#a52a3a] to-[#7D1F2E] shadow-inner" data-id="element-310"></div>
                  {/* Ribbon vertical */}
                  <div className="absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-6 bg-gradient-to-b from-[#7D1F2E] via-[#a52a3a] to-[#7D1F2E] shadow-inner" data-id="element-311"></div>
                  {/* Ribbon bow center */}
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-7 h-7 bg-[#7D1F2E] rounded-full border-[1.5px] border-[#C9A84C] shadow-lg z-10 flex items-center justify-center" data-id="element-312">
                    <span className="text-[#C9A84C] text-xs" data-id="element-313">✦</span>
                  </div>

                  {/* Content area - top */}
                  <div className="flex-1 flex flex-col items-center justify-center relative z-20 px-4 pt-6" data-id="element-314">
                    <div className="flex items-center gap-1 mb-1" data-id="element-315">
                      <div className="w-6 h-px bg-[#C9A84C]/60" data-id="element-316"></div>
                      <span className="text-[#C9A84C] text-[9px] tracking-[0.2em] uppercase font-bold" data-id="element-317">
                        Premium
                      </span>
                      <div className="w-6 h-px bg-[#C9A84C]/60" data-id="element-318"></div>
                    </div>
                    <p className="font-serif text-[#C9A84C] font-bold text-sm leading-tight text-center" data-id="element-319">
                      El Arte del
                    </p>
                    <p className="font-serif text-white font-bold text-base leading-tight text-center" data-id="element-320">
                      Packaging
                    </p>
                    <p className="font-serif text-[#C9A84C] font-bold text-lg leading-tight text-center tracking-wider" data-id="element-321">
                      LUXURY
                    </p>
                  </div>

                  {/* Content area - bottom */}
                  <div className="flex-1 flex flex-col items-center justify-center relative z-20 px-4 pb-4" data-id="element-322">
                    <p className="text-[#C9A84C]/70 text-[10px] tracking-[0.15em] uppercase mb-2" data-id="element-323">
                      para Pastelería
                    </p>
                    <div className="flex items-center gap-1.5" data-id="element-324">
                      <div className="w-1.5 h-1.5 rounded-full bg-[#C9A84C]/50" data-id="element-325"></div>
                      <div className="w-1.5 h-1.5 rounded-full bg-[#C9A84C]" data-id="element-326"></div>
                      <div className="w-1.5 h-1.5 rounded-full bg-[#C9A84C]/50" data-id="element-327"></div>
                    </div>
                  </div>

                  {/* Gold trim bottom */}
                  <div className="h-1.5 bg-gradient-to-r from-transparent via-[#C9A84C] to-transparent" data-id="element-328"></div>
                </div>
              </div>

              {/* Badge */}
              <div className="absolute -top-3 -right-3 w-16 h-16 bg-gradient-to-br from-[#C9A84C] to-[#8B6914] rounded-full flex items-center justify-center shadow-[0_4px_15px_rgba(201,168,76,0.4)] border-2 border-[#E8D48B]" data-id="element-329">
                <span className="text-white text-[9px] font-bold text-center leading-tight uppercase" data-id="element-330">
                  Libro
                  <br data-id="element-331" />
                  Digital
                </span>
              </div>

              {/* Subtle glow */}
              <div className="absolute -inset-4 bg-[#C9A84C]/5 rounded-2xl blur-xl -z-10" data-id="element-332"></div>
            </div>
          </div>

          {/* Price */}
          <p className="text-center mt-5 text-[#3D1F0D] font-bold text-xl md:text-2xl" data-id="element-333">
            Sumalo por solo <span className="text-[#B8860B]" data-id="element-334">$6.000</span>
          </p>
        </motion.div>
      </div>
    </section>;
}